import { ReactComponent as SvgDate } from '@img/icons/date-icon.svg';
import { ReactComponent as SvgPin } from '@img/icons/location-icon.svg';
import { ReactComponent as SvgExternalLink } from '@img/icons/share-icon.svg';
import { ReactComponent as SvgSustainabilityBadge } from '@img/icons/sustainability-icon.svg';
import React from 'react';
import { SustainabilityStatus } from '../HTAMemberCard/HTAMemberCard';
import S from '../HTAMemberCard/HTAMemberCard.styles';
const SupporterCard = ({ address, name, url, sustainabilityStatus, sustainabilityLink, sustainabilityDate, }) => {
    return (React.createElement(S.Container, { variant: `supporterCard${sustainabilityStatus}` },
        React.createElement(S.ContentWrapper, null,
            sustainabilityStatus && (React.createElement(S.SustainabilityHeader, null,
                sustainabilityStatus,
                " Supporter",
                React.createElement(S.SustainabilityBadge, { as: SvgSustainabilityBadge }))),
            url ? (React.createElement(S.TitleLink, { href: url, target: "_self" },
                React.createElement(S.Title, null, name))) : (React.createElement(S.Title, null, name)),
            address && (React.createElement(S.DetailItem, null,
                React.createElement(S.DetailIcon, { as: SvgPin }),
                React.createElement(S.DetailText, null, address))),
            React.createElement(S.DetailBlock, null,
                React.createElement(S.DetailItem, null,
                    React.createElement(S.DetailHeading, null, "Sustainability Plan")),
                sustainabilityLink && sustainabilityStatus === SustainabilityStatus.full && (React.createElement(S.DetailItem, { as: "a", href: sustainabilityLink, target: "_blank", rel: "noopener noreferrer" },
                    React.createElement(S.DetailIcon, { as: SvgExternalLink }),
                    React.createElement(S.DetailText, null, "Visit Website"))),
                sustainabilityDate && sustainabilityStatus === SustainabilityStatus.provisional && (React.createElement(S.DetailItem, null,
                    React.createElement(S.DetailIcon, { as: SvgDate }),
                    React.createElement(S.DetailText, null,
                        "Publishing by ",
                        sustainabilityDate)))))));
};
export default SupporterCard;
